import { useRouter } from 'next/router';
import { useEffect } from 'react';

import * as configuration from '@/configuration/client';
import { useIsUserInitialized, useUser } from '@/providers/Auth';
import { mixpanelTrack } from '@/providers/Mixpanel';

const HandleRedirect: React.FC = () => {
  const [user] = useUser();
  const userIsInitialized = useIsUserInitialized();
  const router = useRouter();
  const path = router.asPath;

  useEffect(() => {
    if (userIsInitialized) {
      let newUrl = `${configuration.GLADE_REDIRECT_TO_HOST}${path}`;
      if (user?.token) {
        if (/\?/.test(path)) {
          newUrl = `${newUrl}&authToken=${user.token}`;
        } else {
          newUrl = `${newUrl}?authToken=${user.token}`;
        }
      }
      mixpanelTrack('Redirecting to app.glade.ai');
      window.location.href = newUrl;
    }
  }, [user, userIsInitialized, path]);
  return null;
};

export default HandleRedirect;
